import { render, staticRenderFns } from "./SubProjectDetails.vue?vue&type=template&id=b91785ae&"
import script from "./SubProjectDetails.vue?vue&type=script&lang=js&"
export * from "./SubProjectDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports